import { useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()

export type LayoutType = 'classic' | 'topLeft' | 'top' | 'cutMenu'

// export type ThemeTypes = {
//   elColorPrimary?: string
//   leftMenuBorderColor?: string
//   leftMenuBgColor?: string
//   leftMenuBgLightColor?: string
//   leftMenuBgActiveColor?: string
//   leftMenuCollapseBgActiveColor?: string
//   leftMenuTextColor?: string
//   leftMenuTextActiveColor?: string
//   logoTitleTextColor?: string
//   logoBorderColor?: string
//   topHeaderBgColor?: string
//   topHeaderTextColor?: string
//   topHeaderHoverColor?: string
//   topToolBorderColor?: string
// }

export type ChartColor = {
  text?: string
  label?: string
  title?: string
  line?: string
  border?: string
  legendTxt?: string
  zoomBorder?: string
  zoomBg?: string
  zoomFill?: string
  zoomFillBorder?: string
  zoomCurFill?: string

  blue?: string
  green?: string
  red?: string
  orange?: string
  yellow?: string
  brightBlue?: string
  purple?: string
  limeGreen?: string
  brightpink?: string
  
  greenBg?: string
  redBg?: string
  orangeBg?: string

  popperBorder?: string
  popperBg?: string
}
export interface AppState {
  version: string
  breadcrumb: boolean
  breadcrumbIcon: boolean
  collapse: boolean
  uniqueOpened: boolean
  hamburger: boolean
  screenfull: boolean
  size: boolean
  locale: boolean
  tagsView: boolean
  tagsViewIcon: boolean
  logo: boolean
  fixedHeader: boolean
  greyMode: boolean
  dynamicRouter: boolean
  pageLoading: boolean
  layout: LayoutType
  title: string
  userInfo: string
  isDark: boolean
  currentSize: ElememtPlusSize
  sizeMap: ElememtPlusSize[]
  mobile: boolean
  footer: boolean
  hideMenu: boolean
  hideHeader: boolean
  theme: string,
  hideDialog: boolean,
  chartColor: ChartColor
}

export const appModules: AppState = {
  version: '',
  userInfo: 'userInfo', // 登录信息存储字段-建议每个项目换一个字段，避免与其他项目冲突
  sizeMap: ['default', 'large', 'small'],
  mobile: false, // 是否是移动端
  title: import.meta.env.VITE_APP_TITLE, // 标题
  pageLoading: false, // 路由跳转loading

  breadcrumb: true, // 面包屑
  breadcrumbIcon: true, // 面包屑图标
  collapse: false, // 折叠菜单
  uniqueOpened: false, // 是否只保持一个子菜单的展开
  hamburger: true, // 折叠图标
  screenfull: true, // 全屏图标
  size: true, // 尺寸图标
  locale: true, // 多语言图标
  tagsView: true, // 标签页
  tagsViewIcon: true, // 是否显示标签图标
  logo: true, // logo
  fixedHeader: true, // 固定toolheader
  footer: true, // 显示页脚
  greyMode: false, // 是否开始灰色模式，用于特殊悼念日
  dynamicRouter: wsCache.get('dynamicRouter') || false, // 是否动态路由

  layout: wsCache.get('layout') || 'classic', // layout布局
  isDark: wsCache.get('isDark') || false, // 是否是暗黑模式
  currentSize: wsCache.get('default') || 'default', // 组件尺寸
  hideMenu: false, // 隐藏菜单
  hideHeader: false, // 隐藏header
  theme: wsCache.get('theme'),
  chartColor:{
    text:'#323233',
    label:'#787878',
    title:'#555',
    line:'#E1E1E1',
    border:'#C8C8C8',
    legendTxt:'#787878',

    blue: '#3381D6',
    green: '#00B900',
    red: '#DF001A',
    orange: '#FF9300',
    yellow: '#EBC147',
    gray:'#787878',
    brightBlue: '#EBC147',
    purple: '#8048C8',
    limeGreen: '#4BD8A5',
    brightpink: '#FB4788',          
    greenBg: '#E1F7E1',
    redBg: '#FBE1E4',
    orangeBg: '#FFEFDA', 
    
    popperBorder: '#FFF', 
    popperBg: '#FFF', 
  }
}
